/*
 * L'AUDACE header behaviour
 * 1. Keeps --header-height equal to the real header height, so the hero can
 *    slide exactly underneath the transparent header (Dawn measures the
 *    section wrapper instead, which is wrong when the header overlaps).
 * 2. Adds .laudace-header-solid to the header section once the header's
 *    bottom edge passes the end of the first (hero) section.
 */
(function () {
  var section = document.querySelector('.section-header');
  var wrap = section && section.querySelector('.header-wrapper');
  if (!section || !wrap) return;

  var root = document.documentElement;
  var transparent = wrap.classList.contains('header-wrapper--transparent');
  var heroEnd = 0;
  var ticking = false;

  function setHeight() {
    var h = wrap.offsetHeight + 'px';
    root.style.setProperty('--header-height', h);
    // Resting height only: the hero sizes itself from this, so it must not change
    // while the header compacts after the hero.
    if (!section.classList.contains('laudace-header-solid')) {
      root.style.setProperty('--laudace-header-full', h);
    }
  }

  function measureHero() {
    var hero = document.querySelector('#MainContent > .shopify-section');
    heroEnd = hero ? hero.getBoundingClientRect().bottom + window.pageYOffset : 0;
  }

  function update() {
    ticking = false;
    if (!transparent) return;
    var past = window.pageYOffset + wrap.offsetHeight >= heroEnd - 1;
    section.classList.toggle('laudace-header-solid', past);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function refresh() {
    setHeight();
    measureHero();
    update();
  }

  refresh();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', refresh);
  window.addEventListener('load', refresh);

  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(refresh);
    ro.observe(wrap);
    var hero = document.querySelector('#MainContent > .shopify-section');
    if (hero) ro.observe(hero);
  }
})();
